import React from 'react';
import { FaLinkedinIn } from 'react-icons/fa';
import systemInsightsLogo from '../../assets/images/SystemInsights.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white">
      <div className="container mx-auto lg:px-10 px-8">
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-6 lg:py-12 py-10">
          <div className="col-span-full lg:col-span-1">
            <div className="lg:max-w-2xl mx-auto">
              <div className="flex items-center lg:justify-start justify-center">
                <img src={systemInsightsLogo} alt="System Insights" className="h-24 me-5" />
              </div>
              <p className="text-gray-700 lg:max-w-xs mt-6 text-sm font-medium leading-7 lg:text-left text-center">
                AI-powered legislative intelligence tools that extend the platforms you already trust. Built by System
                Insights.
              </p>
            </div>
            <ul className="flex items-center mt-6 gap-4 lg:justify-start justify-center">
              <li className="w-8 h-8 flex items-center justify-center bg-gray-200 transition-all duration-500 hover:bg-gold cursor-pointer">
                <a
                  href="https://www.linkedin.com/company/texas-legislative-service"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn color="#374151" />
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-full lg:col-span-1 lg:px-12 px-0 lg:text-left text-center">
            <h4 className="font-bold text-gray-900 uppercase">Platforms</h4>
            <div className="mt-6 grid space-y-3">
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="https://www.telicon.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Telicon (Texas)
                </a>
              </p>
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="https://www.legiscon.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Legiscon (Louisiana)
                </a>
              </p>
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="https://nystatewatch.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NY StateWatch (New York)
                </a>
              </p>
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="https://msstatewatch.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  MS StateWatch (Mississippi)
                </a>
              </p>
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="https://legisok.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LegisOK (Oklahoma)
                </a>
              </p>
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="https://ardigest.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AR Digest (Arkansas)
                </a>
              </p>
            </div>
          </div>

          <div className="col-span-full lg:col-span-1 lg:text-left text-center">
            <h4 className="font-bold text-gray-900 uppercase">AI Tools</h4>
            <div className="mt-6 grid space-y-3">
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="#features"
                >
                  AI Search
                </a>
              </p>
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="#features"
                >
                  Bill Summary
                </a>
              </p>
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="#features"
                >
                  AI Query
                </a>
              </p>
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="#features"
                >
                  Version Comparison
                </a>
              </p>
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="#features"
                >
                  Floor Transcripts
                </a>
              </p>
              <p>
                <a
                  className="inline-flex gap-x-2 text-xs text-gray-700 font-medium transition-all duration-300 hover:text-gold"
                  href="#features"
                >
                  Committee Transcripts
                </a>
              </p>
            </div>
          </div>

          <div className="col-span-full lg:col-span-1 lg:text-left text-center">
            <h4 className="font-bold text-gray-900 uppercase">Contact</h4>
            <div className="mt-6 grid space-y-3">
              <a
                className="inline-flex items-center gap-x-4 text-gray-700 text-xs font-medium leading-8 transition-all duration-300 lg:justify-start justify-center"
                href="https://maps.google.com/?q=919+Congress+Suite+1425+Austin+Texas+78701"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13 7.50012C13 10.3219 8.68174 14.2217 7.37207 15.3396C7.15659 15.5235 6.84341 15.5235 6.62793 15.3396C5.31826 14.2217 1 10.3219 1 7.50012C1 4.17394 3.68629 1.47754 7 1.47754C10.3137 1.47754 13 4.17394 13 7.50012Z"
                    stroke="#DBB079"
                  />
                  <path
                    d="M8.99981 7.06184C8.99981 8.18005 8.10438 9.08653 6.99981 9.08653C5.89524 9.08653 4.99981 8.18005 4.99981 7.06184C4.99981 5.94364 5.89524 5.03716 6.99981 5.03716C8.10438 5.03716 8.99981 5.94364 8.99981 7.06184Z"
                    stroke="#DBB079"
                  />
                </svg>
                919 Congress, Suite 1425 &bull; Austin, Texas 78701
              </a>

              <a
                className="inline-flex items-center gap-x-4 text-gray-700 text-xs font-medium leading-8 transition-all duration-300 lg:justify-start justify-center"
                href="tel:5125963141"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.5 11.1V13.1C14.5 13.6 14.1 14 13.6 14C7.3 14 2 8.7 2 2.4C2 1.9 2.4 1.5 2.9 1.5H4.9C5.2 1.5 5.4 1.7 5.5 2L6.3 4.5C6.4 4.8 6.3 5.1 6 5.3L4.8 6.5C5.8 8.6 7.4 10.2 9.5 11.2L10.7 10C10.9 9.8 11.2 9.7 11.5 9.7L14 10.5C14.3 10.6 14.5 10.8 14.5 11.1Z"
                    stroke="#DBB079"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                (512) 596-3141
              </a>

              <a
                className="inline-flex items-center gap-x-4 text-gray-700 text-xs font-medium leading-8 transition-all duration-300 lg:justify-start justify-center"
                href="mailto:afish@telicon.com"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 1.6H14C14.22 1.6 14.4 1.78 14.4 2V14C14.4 14.22 14.22 14.4 14 14.4H2C1.78 14.4 1.6 14.22 1.6 14V2C1.6 1.78 1.78 1.6 2 1.6ZM13.6 2.4H2.4V3.84L8 7.48L13.6 3.84V2.4ZM13.6 4.64L8 8.28L2.4 4.64V13.6H13.6V4.64Z"
                    fill="#DBB079"
                  />
                </svg>
                afish@telicon.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 py-6">
          <p className="text-center text-sm text-gray-400">
            &copy; {currentYear} System Insights. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
